module.exports = __webpack_public_path__ + "static/media/hero.77b396c1.jpg";